module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5BaGr"))).then(() => parcelRequire('37nVf'));